// src/data/mangoData.js
//
// Mango varieties/prices used to live here as a hardcoded array (and
// duplicated again on the server) - they're admin-managed now, fetched
// from the API in pages/Mango/Mango.jsx. Hero slides stay here as static
// marketing copy, same as the homepage's own hero slides.
export const mangoHeroSlides = [
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1782508317/WhatsApp_Image_2026-06-27_at_02.37.58_neuwec.jpg",
        headline: "🍋 Sweet Summer Mangoes!",
        subheadline: "Fresh, Juicy & Directly from the Farm",
        primaryBtn: "Order Now",
        category: "All"
    },
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1782508317/WhatsApp_Image_2026-06-27_at_02.37.59_p5ort0.jpg",
        headline: "🥭 Premium Quality Mangoes",
        subheadline: "Himshagor, Amrapali, Fazli & More",
        primaryBtn: "Explore Mangoes",
        category: "All"
    },
    {
        img: "https://res.cloudinary.com/do3soodbc/image/upload/v1781812608/WhatsApp_Image_2026-06-18_at_17.37.18_ceut15.jpg",
        headline: "🎁 Bulk Order Available!",
        subheadline: "Perfect for Gifts, Events & Family",
        primaryBtn: "Order in Bulk",
        category: "All"
    }
];